export default __webpack_public_path__ + "static/media/calendar-schedule.c178ca90.svg";